// src/components/Landing/AboutUs.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Header Navigation */}
      <nav className="about-nav">
        <div className="about-nav-content">
          <Link to="/" className="about-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </Link>
          <Link to="/" className="about-back-btn">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span>Voltar ao Site</span>
          </Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>Sobre o DRE Pro</h1>
          <p>Transformando a gestão financeira de empresas brasileiras desde 2024</p>
          <div className="about-hero-stats">
            <div className="about-stat">
              <span className="about-stat-number">85%</span>
              <span className="about-stat-label">Redução em Tempo</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">5x</span>
              <span className="about-stat-label">Melhores Decisões</span>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="about-content">
        <div className="about-container">
          {/* Table of Contents */}
          <aside className="about-toc">
            <h3>Navegação</h3>
            <ul>
              <li><a href="#mission">Nossa Missão</a></li>
              <li><a href="#story">Nossa História</a></li>
              <li><a href="#values">Nossos Valores</a></li>
              <li><a href="#technology">Tecnologia</a></li>
              <li><a href="#team">Nossa Equipe</a></li>
              <li><a href="#achievements">Conquistas</a></li>
              <li><a href="#future">Visão de Futuro</a></li>
              <li><a href="#contact">Contato</a></li>
            </ul>
          </aside>

          {/* About Content */}
          <article className="about-article">
            <section id="mission" className="about-section">
              <h2>NOSSA MISSÃO</h2>
              <div className="about-mission-content">
                <div className="about-mission-main">
                  <h3>Democratizar a Gestão Financeira Inteligente</h3>
                  <p>
                    Acreditamos que toda empresa, independente do seu tamanho, merece ter acesso 
                    a ferramentas de gestão financeira de qualidade empresarial. Nossa missão é 
                    simplificar a contabilidade e tornar a análise financeira acessível para 
                    empreendedores brasileiros.
                  </p>
                  <p>
                    Transformamos dados financeiros complexos em insights acionáveis, permitindo 
                    que nossos clientes tomem decisões mais inteligentes e façam seus negócios 
                    prosperarem no mercado competitivo atual.
                  </p>
                </div>
                
                <div className="about-mission-cards">
                  <div className="about-mission-card">
                    <div className="about-card-icon">🎯</div>
                    <h4>Foco no Cliente</h4>
                    <p>Desenvolvemos soluções pensando nas necessidades reais dos empreendedores brasileiros</p>
                  </div>
                  <div className="about-mission-card">
                    <div className="about-card-icon">🚀</div>
                    <h4>Inovação Contínua</h4>
                    <p>Utilizamos inteligência artificial e tecnologias modernas para automatizar processos</p>
                  </div>
                  <div className="about-mission-card">
                    <div className="about-card-icon">🤝</div>
                    <h4>Parceria de Sucesso</h4>
                    <p>Somos parceiros no crescimento e sucesso dos nossos clientes</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="story" className="about-section">
              <h2>NOSSA HISTÓRIA</h2>
              <div className="about-story">
                <div className="about-story-content">
                  <h3>Do Problema à Solução</h3>
                  <p>
                    O DRE Pro nasceu da frustração real vivenciada por empreendedores brasileiros 
                    que enfrentavam dificuldades na gestão financeira de seus negócios. Em 2024, 
                    nossa equipe identificou que muitas empresas perdiam horas preciosas organizando 
                    planilhas complexas e tentando entender a real situação financeira de suas operações.
                  </p>
                  
                  <div className="about-story-timeline">
                    <div className="about-timeline-item">
                      <div className="about-timeline-date">Janeiro 2024</div>
                      <div className="about-timeline-content">
                        <h4>Início da Jornada</h4>
                        <p>Identificação do problema e início do desenvolvimento da primeira versão</p>
                      </div>
                    </div>
                    
                    <div className="about-timeline-item">
                      <div className="about-timeline-date">Março 2024</div>
                      <div className="about-timeline-content">
                        <h4>MVP Lançado</h4>
                        <p>Primeira versão funcional com importação de OFX e categorização básica</p>
                      </div>
                    </div>
                    
                    <div className="about-timeline-item">
                      <div className="about-timeline-date">Junho 2024</div>
                      <div className="about-timeline-content">
                        <h4>IA Implementada</h4>
                        <p>Lançamento da categorização automática com inteligência artificial</p>
                      </div>
                    </div>
                    
                    <div className="about-timeline-item">
                      <div className="about-timeline-date">Setembro 2024</div>
                      <div className="about-timeline-content">
                        <h4>Relatórios DRE</h4>
                        <p>Introdução de relatórios profissionais de Demonstração de Resultado</p>
                      </div>
                    </div>
                    
                    <div className="about-timeline-item">
                      <div className="about-timeline-date">Dezembro 2024</div>
                      <div className="about-timeline-content">
                        <h4>Cálculos Tributários</h4>
                        <p>Lançamento do módulo de comparação de regimes tributários</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="values" className="about-section">
              <h2>NOSSOS VALORES</h2>
              <div className="about-values">
                <div className="about-values-grid">
                  <div className="about-value-card">
                    <div className="about-value-icon">🔒</div>
                    <h3>Segurança e Confiança</h3>
                    <p>
                      Protegemos os dados financeiros dos nossos clientes com os mais altos padrões 
                      de segurança. Cada informação é tratada com confidencialidade absoluta e 
                      criptografada em todas as etapas do processo.
                    </p>
                  </div>
                  
                  <div className="about-value-card">
                    <div className="about-value-icon">💡</div>
                    <h3>Simplicidade e Usabilidade</h3>
                    <p>
                      Acreditamos que tecnologia complexa deve resultar em experiências simples. 
                      Desenvolvemos interfaces intuitivas que qualquer empreendedor pode usar, 
                      independente de seu conhecimento técnico.
                    </p>
                  </div>
                  
                  <div className="about-value-card">
                    <div className="about-value-icon">📊</div>
                    <h3>Precisão e Qualidade</h3>
                    <p>
                      Nossos algoritmos são rigorosamente testados para garantir a máxima precisão 
                      nos cálculos e categorizações. A qualidade dos dados é fundamental para 
                      decisões financeiras acertadas.
                    </p>
                  </div>
                  
                  <div className="about-value-card">
                    <div className="about-value-icon">🌱</div>
                    <h3>Crescimento Sustentável</h3>
                    <p>
                      Apoiamos o crescimento sustentável dos negócios dos nossos clientes, fornecendo 
                      insights que promovem decisões financeiras responsáveis e estratégicas a 
                      longo prazo.
                    </p>
                  </div>
                  
                  <div className="about-value-card">
                    <div className="about-value-icon">🤖</div>
                    <h3>Inovação Inteligente</h3>
                    <p>
                      Utilizamos inteligência artificial e machine learning não por modismo, mas 
                      para resolver problemas reais. Cada nova tecnologia implementada tem um 
                      propósito claro de melhorar a vida dos usuários.
                    </p>
                  </div>
                  
                  <div className="about-value-card">
                    <div className="about-value-icon">❤️</div>
                    <h3>Atendimento Humanizado</h3>
                    <p>
                      Por trás da tecnologia estão pessoas reais, prontas para ajudar. Nosso 
                      suporte é feito por especialistas que entendem tanto de tecnologia quanto 
                      das necessidades dos empreendedores brasileiros.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section id="technology" className="about-section">
              <h2>NOSSA TECNOLOGIA</h2>
              <div className="about-technology">
                <div className="about-tech-intro">
                  <h3>Infraestrutura de Classe Mundial</h3>
                  <p>
                    Construímos o DRE Pro utilizando as mais modernas tecnologias disponíveis no mercado, 
                    garantindo performance, segurança e escalabilidade para atender empresas de todos os tamanhos.
                  </p>
                </div>
                
                <div className="about-tech-stack">
                  <div className="about-tech-category">
                    <h4>🎨 Frontend</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">React.js</span>
                      <span className="about-tech-item">TypeScript</span>
                      <span className="about-tech-item">Material-UI</span>
                      <span className="about-tech-item">CSS3 Moderno</span>
                    </div>
                  </div>
                  
                  <div className="about-tech-category">
                    <h4>⚙️ Backend</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Node.js</span>
                      <span className="about-tech-item">Express.js</span>
                      <span className="about-tech-item">Firebase Functions</span>
                      <span className="about-tech-item">RESTful APIs</span>
                    </div>
                  </div>
                  
                  <div className="about-tech-category">
                    <h4>🗄️ Banco de Dados</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Cloud Firestore</span>
                      <span className="about-tech-item">Firebase Storage</span>
                      <span className="about-tech-item">Backup Automático</span>
                      <span className="about-tech-item">Criptografia AES-256</span>
                    </div>
                  </div>
                  
                  <div className="about-tech-category">
                    <h4>🤖 Inteligência Artificial</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Machine Learning</span>
                      <span className="about-tech-item">Processamento de Linguagem</span>
                      <span className="about-tech-item">Análise Preditiva</span>
                      <span className="about-tech-item">Algoritmos Proprietários</span>
                    </div>
                  </div>
                  
                  <div className="about-tech-category">
                    <h4>☁️ Infraestrutura</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">Google Cloud Platform</span>
                      <span className="about-tech-item">CDN Global</span>
                      <span className="about-tech-item">Auto Scaling</span>
                      <span className="about-tech-item">Monitoramento 24/7</span>
                    </div>
                  </div>
                  
                  <div className="about-tech-category">
                    <h4>🔐 Segurança</h4>
                    <div className="about-tech-items">
                      <span className="about-tech-item">HTTPS/TLS 1.3</span>
                      <span className="about-tech-item">Autenticação OAuth</span>
                      <span className="about-tech-item">Firewall Avançado</span>
                      <span className="about-tech-item">Auditoria de Segurança</span>
                    </div>
                  </div>
                </div>
                
                <div className="about-tech-certifications">
                  <h4>🏆 Certificações e Compliance</h4>
                  <div className="about-certifications-grid">
                    <div className="about-cert-item">
                      <span className="about-cert-badge">LGPD</span>
                      <p>Conformidade com Lei Geral de Proteção de Dados</p>
                    </div>
                    <div className="about-cert-item">
                      <span className="about-cert-badge">ISO 27001</span>
                      <p>Padrões internacionais de segurança da informação</p>
                    </div>
                    <div className="about-cert-item">
                      <span className="about-cert-badge">SOC 2</span>
                      <p>Certificação de controles de segurança e disponibilidade</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="team" className="about-section">
              <h2>NOSSA EQUIPE</h2>
              <div className="about-team">
                <div className="about-team-intro">
                  <h3>Especialistas Apaixonados por Inovação</h3>
                  <p>
                    Nossa equipe multidisciplinar combina expertise em tecnologia, contabilidade e 
                    experiência do usuário para criar soluções que realmente fazem a diferença na 
                    vida dos empreendedores.
                  </p>
                </div>
                
                <div className="about-team-departments">
                  <div className="about-department">
                    <h4>💻 Desenvolvimento</h4>
                    <div className="about-department-content">
                      <p>
                        Engenheiros de software sênior com experiência em fintech e sistemas críticos. 
                        Especialistas em React, Node.js, inteligência artificial e arquitetura de microsserviços.
                      </p>
                      <div className="about-team-skills">
                        <span>Full-Stack Development</span>
                        <span>DevOps & Cloud</span>
                        <span>Machine Learning</span>
                        <span>Security Engineering</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="about-department">
                    <h4>📊 Contabilidade e Finanças</h4>
                    <div className="about-department-content">
                      <p>
                        Contadores e especialistas em finanças corporativas com profundo conhecimento 
                        da legislação brasileira e melhores práticas de gestão financeira.
                      </p>
                      <div className="about-team-skills">
                        <span>CRC Ativos</span>
                        <span>Legislação Tributária</span>
                        <span>Análise Financeira</span>
                        <span>Compliance Fiscal</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="about-department">
                    <h4>🎨 Design e UX</h4>
                    <div className="about-department-content">
                      <p>
                        Designers especializados em UX/UI para produtos financeiros, focados em criar 
                        interfaces intuitivas que simplificam processos complexos.
                      </p>
                      <div className="about-team-skills">
                        <span>User Experience</span>
                        <span>Interface Design</span>
                        <span>User Research</span>
                        <span>Prototipagem</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="about-department">
                    <h4>🤝 Atendimento ao Cliente</h4>
                    <div className="about-department-content">
                      <p>
                        Especialistas em suporte técnico e success que entendem tanto de tecnologia 
                        quanto das necessidades específicas de cada tipo de negócio.
                      </p>
                      <div className="about-team-skills">
                        <span>Suporte Técnico</span>
                        <span>Customer Success</span>
                        <span>Treinamento</span>
                        <span>Consultoria</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="about-team-culture">
                  <h4>🌟 Nossa Cultura</h4>
                  <div className="about-culture-grid">
                    <div className="about-culture-item">
                      <h5>Aprendizado Contínuo</h5>
                      <p>Investimos no desenvolvimento da nossa equipe com cursos, certificações e conferências</p>
                    </div>
                    <div className="about-culture-item">
                      <h5>Colaboração Aberta</h5>
                      <p>Promovemos um ambiente onde ideias fluem livremente entre todas as áreas</p>
                    </div>
                    <div className="about-culture-item">
                      <h5>Inovação Responsável</h5>
                      <p>Testamos novas tecnologias sempre pensando no impacto real para nossos usuários</p>
                    </div>
                    <div className="about-culture-item">
                      <h5>Work-Life Balance</h5>
                      <p>Acreditamos que pessoas equilibradas criam melhores soluções</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="achievements" className="about-section">
              <h2>NOSSAS CONQUISTAS</h2>
              <div className="about-achievements">
                <div className="about-achievements-grid">
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">1000+</div>
                    <h4>Empresas Atendidas</h4>
                    <p>Mais de mil empresas já confiam no DRE Pro para sua gestão financeira</p>
                  </div>
                  
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">50M+</div>
                    <h4>Transações Processadas</h4>
                    <p>Mais de 50 milhões de transações categorizadas automaticamente</p>
                  </div>
                  
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">99.9%</div>
                    <h4>Disponibilidade</h4>
                    <p>Uptime consistente garantindo acesso quando você mais precisa</p>
                  </div>
                  
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">85%</div>
                    <h4>Redução de Tempo</h4>
                    <p>Economia média de tempo em tarefas de organização financeira</p>
                  </div>
                  
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">200K+</div>
                    <h4>Horas Economizadas</h4>
                    <p>Tempo total poupado pelos clientes em tarefas manuais de organização financeira</p>
                  </div>
                  
                  <div className="about-achievement-card">
                    <div className="about-achievement-number">24h</div>
                    <h4>Tempo de Resposta</h4>
                    <p>Tempo médio para primeira resposta do suporte técnico</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="future" className="about-section">
              <h2>VISÃO DE FUTURO</h2>
              <div className="about-future">
                <div className="about-future-vision">
                  <h3>Construindo o Futuro da Gestão Financeira</h3>
                  <p>
                    Nossa visão é nos tornarmos a principal plataforma de gestão financeira para 
                    pequenas e médias empresas no Brasil, expandindo gradualmente para outros 
                    países da América Latina.
                  </p>
                </div>
                
                <div className="about-roadmap">
                  <h4>🛣️ Roadmap 2025-2026</h4>
                  <div className="about-roadmap-items">
                    <div className="about-roadmap-item">
                      <div className="about-roadmap-quarter">Q1 2025</div>
                      <div className="about-roadmap-content">
                        <h5>Integração Bancária Direta</h5>
                        <p>Conexão direta com principais bancos brasileiros via Open Banking</p>
                      </div>
                    </div>
                    
                    <div className="about-roadmap-item">
                      <div className="about-roadmap-quarter">Q2 2025</div>
                      <div className="about-roadmap-content">
                        <h5>App Mobile Nativo</h5>
                        <p>Aplicativo para iOS e Android com funcionalidades completas</p>
                      </div>
                    </div>
                    
                    <div className="about-roadmap-item">
                      <div className="about-roadmap-quarter">Q3 2025</div>
                      <div className="about-roadmap-content">
                        <h5>IA Preditiva Avançada</h5>
                        <p>Previsões de fluxo de caixa e análises preditivas personalizadas</p>
                      </div>
                    </div>
                    
                    <div className="about-roadmap-item">
                      <div className="about-roadmap-quarter">Q4 2025</div>
                      <div className="about-roadmap-content">
                        <h5>Marketplace de Integrações</h5>
                        <p>Ecossistema de integrações com ERPs, e-commerce e outras ferramentas</p>
                      </div>
                    </div>
                    
                    <div className="about-roadmap-item">
                      <div className="about-roadmap-quarter">2026</div>
                      <div className="about-roadmap-content">
                        <h5>Expansão Internacional</h5>
                        <p>Lançamento em outros países da América Latina</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="about-commitment">
                  <h4>💪 Nosso Compromisso</h4>
                  <div className="about-commitment-grid">
                    <div className="about-commitment-item">
                      <div className="about-commitment-icon">🌱</div>
                      <h5>Crescimento Sustentável</h5>
                      <p>Crescer sempre mantendo a qualidade e o atendimento personalizado</p>
                    </div>
                    <div className="about-commitment-item">
                      <div className="about-commitment-icon">🔬</div>
                      <h5>Inovação Constante</h5>
                      <p>Investir continuamente em pesquisa e desenvolvimento de novas funcionalidades</p>
                    </div>
                    <div className="about-commitment-item">
                      <div className="about-commitment-icon">🤝</div>
                      <h5>Parceria Duradoura</h5>
                      <p>Ser um parceiro de longo prazo no sucesso dos nossos clientes</p>
                    </div>
                    <div className="about-commitment-item">
                      <div className="about-commitment-icon">🌍</div>
                      <h5>Impacto Social</h5>
                      <p>Contribuir para o fortalecimento do ecossistema empreendedor brasileiro</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="contact" className="about-section">
              <h2>CONTATO</h2>
              <div className="about-contact">
                <div className="about-contact-intro">
                  <h3>Fale Conosco</h3>
                  <p>
                    Estamos sempre disponíveis para esclarecer dúvidas e ajudar você 
                    a transformar a gestão financeira da sua empresa.
                  </p>
                </div>
                
                <div className="about-main-contact">
                  <h4>📞 Contato Principal</h4>
                  <div className="about-main-contact-info">
                    <div className="about-main-contact-item">
                      <span className="about-contact-label">WhatsApp:</span>
                      <span className="about-contact-value">+55 41 3798-4531</span>
                    </div>
                    <div className="about-main-contact-item">
                      <span className="about-contact-label">Email Geral:</span>
                      <span className="about-contact-value">contato@drepro.com.br</span>
                    </div>
                    <div className="about-main-contact-item">
                      <span className="about-contact-label">Suporte:</span>
                      <span className="about-contact-value">suporte@drepro.com.br</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="about-footer-text">
              <p>
                <strong>
                  Obrigado por conhecer nossa história. Estamos ansiosos para fazer 
                  parte da jornada de sucesso da sua empresa!
                </strong>
              </p>
              <p className="about-cta-text">
                Pronto para transformar sua gestão financeira? 
                <Link to="/" className="about-cta-link">Conheça nossos planos</Link>
              </p>
            </div>
          </article>
        </div>
      </main>

      {/* Footer */}
      <footer className="about-footer">
        <div className="about-footer-content">
          <Link to="/" className="about-footer-logo">
            <img src="/logolandingpage.png" alt="DRE Pro Logo" />
          </Link>
          <p>&copy; {new Date().getFullYear()} DRE Pro. Transformando gestão financeira desde 2024.</p>
          <Link to="/" className="about-footer-back">
            Voltar ao Site Principal
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;